import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import MyCSRReceiptEventCountForm from "./my-csr-receipt-event-count-form";
import MyCSRReceiptEventCountData from "./my-csr-receipt-event-count-data";

const MyCSRReceiptEventCount = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "CSR_MY_RECEIPT_EVENT_COUNT",
      "CSR_MY_RECEIPT_EVENT_COUNT"
    );
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("CSR_MY_RECEIPT_EVENT_COUNT")}
        subTitle={i18n.get("CSR_MY_RECEIPT_EVENT_COUNT")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <MyCSRReceiptEventCountForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <MyCSRReceiptEventCountData />
    </ET3PageDiv>
  );
});
export default MyCSRReceiptEventCount;
